function setDisplayVariables(n)
{
  const defaultHeight = 740;
  const defaultWidth = 1280;
//canvas variables
canvasWidth = $('#displayScreen').width();
// determine the height based on width, considering the default proportions
canvasHeight = Math.round(canvasWidth / (defaultWidth/defaultHeight) );
$('#displayScreen').height(canvasHeight + 'px');
//image variables
borderImage = 4;
spaceTargetImages = adjuster * 50;
space2images = adjuster * 30;
space3images = adjuster * 30;
space4images = adjuster * 20;
space5images = adjuster * 20;
space6images = adjuster * 20;
// word variables
spaceTargetWords = adjuster * 120;
wordHeight = adjuster * 50;
width1word = adjuster * canvasWidth;
width2words = adjuster * 200;
width3words = adjuster * 200;
width4words = adjuster * 200;
width5words = adjuster * 180;
width6words = adjuster * 160;
space2words = adjuster * 30;
space3words = adjuster * 30;
space4words = adjuster * 30;
space5words = adjuster * 30;
space6words = adjuster * 30;
// button variables
width1button = adjuster * 250;
width2buttons = adjuster * 220;
width3buttons = adjuster * 200;
width4buttons = adjuster * 180;
width5buttons = adjuster * 160;
width6buttons = adjuster * 140;
width7buttons = adjuster * 120;
width8buttons = adjuster * 100;
width9buttons = adjuster * 90;
width10buttons = adjuster * 90;
width11buttons = adjuster * 90;
width12buttons = adjuster * 90;
space2buttons = adjuster * 30;
space3buttons = adjuster * 30;
space4buttons = adjuster * 30;
space5buttons = adjuster * 30;
space6buttons = adjuster * 30;
space7buttons = adjuster * 30;
space8buttons = adjuster * 30;
space9buttons = adjuster * 30;
space10buttons = adjuster * 20;
space11buttons = adjuster * 20;
space12buttons = adjuster * 20;
buttonTopDefault = Math.round(adjuster * canvasHeight * 680 / defaultHeight);
spaceImagesResponses = adjuster * 30;
spaceWordsResponses = adjuster * 50;
spaceAudioResponses = adjuster * 50;
spaceVideoResponses = adjuster * 50;
spaceSurveyResponses = adjuster * 50;
// text trial distances
spaceImagesText = adjuster * 8;
spaceVideoText = spaceImagesText;
spaceWordsText = adjuster * 50;
spaceAudioText = spaceWordsText;
// audio variables
audio1width = adjuster * 400;
audio1height = adjuster * 30;
document.getElementById("audio1").style.width = audio1width + "px";
document.getElementById("audio1").style.height = audio1height + "px";
document.getElementById("audio1").style.top = (canvasHeight/2 - audio1height/2) + "px";
document.getElementById("audio1").style.left = (canvasWidth/2 - audio1width/2) + "px";
//very important to get these values before, immediately after preloading is complete
imageTargetWidth = adjuster * 300;//
imageTargetHeight = adjuster * 300;
imageTargetTopAlone = adjuster * 20;
image1width = adjuster * 300;
image1height = adjuster * 300;
image2width = adjuster * 300;
image2height = adjuster * 300;
image3width = adjuster * 300;
image3height = adjuster * 300;
image4width = adjuster * 300;
image4height = adjuster * 300;
// video variables ???????????????
// video1width = adjuster * 384;
// video1height = adjuster * 432;
//consent
consentTop = adjuster * 30;
//text
defaultButtonText = textScreens['pdetails'][language][10];
}